import React, { FC } from 'react';
import { Colors } from '../../../../styles/colors';

interface Props {
  color: string;
}

export const ProductIconTranchenmodellEco: FC<Props> = ({ color = Colors.white }) => {
  return (
    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px" viewBox="0 0 126.8 133.6" style={{ color }} xmlSpace="preserve" fill="currentColor">
      <path d="M63.6,131.3h-4v-13h4V131.3z M82.3,130.7c-0.6,0-1.2-0.3-1.5-0.7L41.9,83.3c-0.5-0.6-0.6-1.4-0.3-2.1c0.3-0.7,1-1.2,1.8-1.2
      h16.2V61.2c0-1.1,0.9-2,2-2H78L43.4,17.6L8.8,59.2h16.5c1.1,0,2,0.9,2,2v51.9h-4V63.2H4.5c-0.8,0-1.5-0.4-1.8-1.2
      c-0.3-0.7-0.2-1.5,0.3-2.1l38.9-46.7c0.8-0.9,2.3-0.9,3.1,0l38.9,46.7c0.5,0.6,0.6,1.4,0.3,2.1c-0.3,0.7-1,1.2-1.8,1.2H63.6V82
      c0,1.1-0.9,2-2,2H47.7l34.6,41.6L117,84h-16.5c-1.1,0-2-0.9-2-2V24.9h4V80h18.8c0.8,0,1.5,0.4,1.8,1.2c0.3,0.7,0.2,1.5-0.3,2.1
      L83.9,130C83.5,130.4,82.9,130.7,82.3,130.7z M40.2,126.1h-4V97.5h4V126.1z M89.5,40.5h-4V6.7h4V40.5z M66.2,24.9h-4v-13h4V24.9z" />
          <g>
            <defs>
              <rect id="SVGID_1_" x="-89.4" y="-529" width="595.3" height="841.9" />
            </defs>
                  <clipPath id="SVGID_2_">
              <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />
            </clipPath>
                  <g className="st0" style={{ clipPath: 'url(#SVGID_2_)' }}>
              <path d="M43.1,47.4c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5C43.6,47.2,43.4,47.4,43.1,47.4
                C43.1,47.4,43.1,47.4,43.1,47.4 M43.1,45.4c-0.9,0-1.6,0.7-1.5,1.6c0,0.9,0.7,1.6,1.6,1.5c0.9,0,1.5-0.7,1.5-1.6
                C44.7,46.1,44,45.4,43.1,45.4C43.1,45.4,43.1,45.4,43.1,45.4" />
                    <path d="M81.4,86.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5c0,0,0,0,0,0C81.9,86.2,81.7,86.4,81.4,86.4
                C81.4,86.4,81.4,86.4,81.4,86.4 M81.4,84.4c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6c0,0,0,0,0,0
                C82.9,85.1,82.2,84.4,81.4,84.4C81.4,84.4,81.4,84.4,81.4,84.4" />
                    <path d="M43.1,44.7c0.2,0,0.4,0,0.6,0.1c0.3-1.4,0.5-2.8,0.5-4.2c0-1.9-0.3-3.7-0.8-5.5c-0.1-0.2-0.2-0.2-0.4-0.2
                c-0.1,0-0.2,0.1-0.2,0.2c-0.5,1.8-0.8,3.7-0.8,5.5c0,1.4,0.2,2.8,0.5,4.2C42.7,44.7,42.9,44.7,43.1,44.7" />
                    <path d="M81.4,83.7c0.2,0,0.4,0,0.6,0.1c0.7-3.2,0.6-6.6-0.3-9.8c0-0.2-0.2-0.2-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.2
                c-0.9,3.2-1,6.5-0.3,9.7C81,83.7,81.2,83.7,81.4,83.7" />
                    <path d="M40.9,47.5c-1.4,0.4-2.7,1-3.9,1.7c-1.6,0.9-3.1,2.1-4.4,3.4c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.1,0.2,0.1,0.2,0.1
                c1.8-0.5,3.5-1.2,5.2-2.1c1.2-0.7,2.4-1.6,3.4-2.5C41.2,48.3,41,47.9,40.9,47.5" />
                    <path d="M79.2,86.5c-1.4,0.4-2.7,1-3.9,1.7c-1.6,0.9-3.1,2.1-4.4,3.4c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.1,0.2,0.1,0.3,0.1
                c1.8-0.5,3.5-1.2,5.2-2.1c1.2-0.7,2.4-1.6,3.4-2.5C79.5,87.3,79.3,86.9,79.2,86.5" />
                    <path d="M53.6,52.7c-1.3-1.3-2.8-2.5-4.4-3.4c-1.2-0.7-2.5-1.3-3.9-1.7c-0.1,0.4-0.3,0.7-0.6,1c2.4,2.2,5.4,3.8,8.6,4.6
                c0.2,0,0.3-0.1,0.4-0.2C53.6,52.8,53.6,52.7,53.6,52.7" />
                    <path d="M91.8,91.7c-1.3-1.3-2.8-2.5-4.4-3.4c-1.2-0.7-2.5-1.3-3.9-1.7c-0.1,0.4-0.3,0.7-0.6,1c1.1,1,2.2,1.8,3.4,2.5
                c1.6,0.9,3.4,1.6,5.2,2.1c0.2,0,0.3,0,0.4-0.2C92,91.8,91.9,91.7,91.8,91.7" />
                    <path d="M43.1,49.2c-0.1,0-0.3,0-0.4,0l-0.9,19.2h2.6l-0.9-19.3C43.4,49.2,43.2,49.2,43.1,49.2" />
                    <path d="M81.4,88.2c-0.1,0-0.3,0-0.4,0l-0.9,19.2h2.6l-0.9-19.2C81.6,88.2,81.5,88.2,81.4,88.2" />
            </g>
          </g>
    </svg>
  );
};
